import { Injectable } from '@angular/core'
import { PreloadingStrategy, Route } from '@angular/router'
import { Observable, of } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class AppRoutePreloadingStrategy implements PreloadingStrategy {
   private readonly preloadableGroups = new Set(['dashboard', 'partners', 'wbs', 'budget', 'lump-sum', 'calendar', 'doodles', 'mailing-list'])
   private requestedGroups = new Set<string>()

   requestGroup(group: string): boolean {
      if (!this.preloadableGroups.has(group) || this.requestedGroups.has(group)) return false

      this.requestedGroups.add(group)
      return true
   }

   preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
      const group = route.data?.['preloadGroup']
      return group && this.requestedGroups.has(group) ? load() : of(null)
   }
}
